import { render } from "./LeadershipChallengeCharacteristics.vue?vue&type=template&id=4a436bd6"
import script from "./LeadershipChallengeCharacteristics.vue?vue&type=script&lang=js"
export * from "./LeadershipChallengeCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script